<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-object-input
                v-if="lv_editable"

                :option="option"
                :show-key="showKey"
                :map="map"
                :row="showRow"

                :beforeSelect="beforeSelect"
                :afterSelect="afterSelect"

                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="null"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: "link-table-column-object-item",
        components: {LvScopeSlot, LvColumnText},
        mixins: [ColumnItemMixin],
        props: {
            option: {},
            showKey: {},
            map: {},

            beforeSelect: {type: Function},
            afterSelect: {type: Function},
        },
    }
</script>
